/**
 * Convert AppCharge amount units to Adyen `amount.value` minor units.
 *
 * For most currencies AppCharge already stores Adyen minor units (no-op).
 * For CLP / CVE / IDR, Adyen's decimals differ from ISO / our storage, so we
 * must rescale — otherwise Apple Pay's token amount won't match `/payments`
 * and Adyen rejects with amount-mismatch.
 *
 * Multipliers must match psps-management `normalizeToAdyenAmount` exactly
 * (no extra rounding) so the Apple Pay token and `/payments` value are
 * identical.
 *
 * @see https://docs.adyen.com/development-resources/currency-codes/
 * @see https://docs.adyen.com/payment-methods/apple-pay/handle-apple-pay-errors#5001-apple-pay-token-amount-mismatch
 */
const ADYEN_AMOUNT_MULTIPLIERS: Record<string, number> = {
  // Adyen: 2 dp (ISO: 0) → scale up to Adyen minor units
  CLP: 100,
  // Adyen: 0 dp; we store with extra ×100 precision → scale down
  CVE: 0.01,
  IDR: 0.01,
};

export function normalizeToAdyenAmount(amount: number, currencyCode: string): number {
  const multiplier = ADYEN_AMOUNT_MULTIPLIERS[currencyCode.toUpperCase()];
  return multiplier == null ? amount : amount * multiplier;
}
